export default "__VITE_ASSET__CzLvNdbW__"